import { Table, UnstyledButton } from '@mantine/core';

import { IconArrowsSort, IconSortAscending, IconSortDescending } from '@tabler/icons-react';

import { ScudTh } from './ScudTable';
import classes from './SortableTh.module.css';

type SortableThProps<T extends string> = {
	children: string;
	field?: T;
	sort: T;
	desc: boolean;
	onSort: (field: T) => void;
	width?: number | string;
};

export const SortableTh = <T extends string>({
	children,
	field,
	sort,
	desc,
	onSort,
	width,
}: SortableThProps<T>) => {
	if (!field) {
		return <ScudTh width={width}>{children}</ScudTh>;
	}

	const isActive = sort === field;
	const ActiveIcon = desc ? IconSortDescending : IconSortAscending;
	const Icon = isActive ? ActiveIcon : IconArrowsSort;
	const direction = desc ? 'descending' : 'ascending';
	// Последнее слово склеено со значком, чтобы значок не переносился на строку один
	const words = children.split(' ');
	const lastWord = words.pop();

	return (
		<Table.Th w={width} aria-sort={isActive ? direction : 'none'}>
			<UnstyledButton
				className={classes.button}
				data-active={isActive || undefined}
				onClick={() => onSort(field)}
			>
				{words.length > 0 && `${words.join(' ')} `}
				<span className={classes.nowrap}>
					{lastWord}
					<Icon size={14} stroke={1.8} className={classes.icon} />
				</span>
			</UnstyledButton>
		</Table.Th>
	);
};
